import ResizeObserverHeightTracker from './height-tracker'
import {ensureIframeMessenger, isNotIframeContext} from './iframe'

const iframeMessenger = ensureIframeMessenger()

export function setupIframeResizeMessenger(setupFunc?: () => void) {
  // Optimization, lets not attach any listeners if we are not in an iframe
  if (isNotIframeContext()) return

  // Start tracking the document within the iframe immediately on load
  const observer = new ResizeObserverHeightTracker({
    node: document.documentElement || document.body,
    onResize(height: number): void {
      if (iframeMessenger.didAck()) {
        iframeMessenger.post('resize', {height})
      }
    },
  })

  observer.observe()

  if (setupFunc) {
    setupFunc()
  }
}

export function initDefaultListeners() {
  setupIframeResizeMessenger()
}

export default iframeMessenger
